import { Modal, ModalBody, ModalHeader, CardBody, CardTitle } from 'reactstrap'
import { IconRefresh, IconX } from '@tabler/icons-react'
//@ts-ignore
import { Button } from 'dsm-react-lib'

interface RemoveAllDataSourcesModalProps {
  isOpen: boolean
  toggle: () => void
  onRemove: () => void
}

const RemoveAllDataSourcesModal: React.FC<RemoveAllDataSourcesModalProps> = ({
  isOpen,
  toggle,
  onRemove
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered data-testid="remove-all-data-sources-modal">
      <ModalHeader
        className={`!justify-between !border-0 !flex !items-center chat-primary theme-bg`}
        toggle={toggle}
        close={
          <IconX
            size={24}
            onClick={toggle}
            className="theme-text-subheading transition-colors duration-300 ease-in-out hover:text-white cursor-pointer"
            data-testid="close-button"
          />
        }>
        <div className="flex items-center">
          <IconRefresh className="me-1" color="white" />
          <span className="text-white">Reset data sources</span>
        </div>
      </ModalHeader>
      <ModalBody className="flex-grow-1">
        <div className="text-left border-0">
          <CardBody className="px-0 py-1">
            <CardTitle tag="h4">
              Are you sure you want to reset the data sources to the agent&apos;s default
              configuration?
            </CardTitle>
            <p className="theme-text-subheading mb-0 mt-1">
              This removes the files, databoxes, and data products you added in this chat, and
              restores the data sources configured on the agent by default.
            </p>
          </CardBody>
        </div>
        <div className={`flex justify-end gap-1 my-1 chat-primary`}>
          <Button
            label="Cancel"
            variant="outline"
            color="neutral"
            className="dsm-btn-neutral"
            onClick={toggle}
            data-testid="cancel-remove-all-sources-button"
          />
          <Button
            label="Reset"
            color="danger"
            onClick={onRemove}
            data-testid="confirm-remove-all-sources-button"
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

export default RemoveAllDataSourcesModal
